<template>
<div class="club-card">
    <a :href="club.url" class="coverimage-header-top coverimage-header-listing site-bg" :style="coverStyle">
        <h1 class="coverimage-text-wrapper">
            <span class="coverimage-text">
                {{ club.name }}
            </span>
        </h1>
        <i v-if="club.highlighted" class="fa fa-star club-highlight" :title="t.featured_club"></i>
        <div class="coverimage-icon">
            <i class="fa fa-glass"></i>
        </div>
        <slot></slot>
    </a>
    <div :class="['club-location', { 'club-has-distance': club.distance }]">
        <i class="fa fa-map-marker"></i> {{ club.location }}
        <span class="club-distance" v-if="club.distance">{{ club.distance }}{{ club.distanceUnit }}</span>
    </div>
    <div class="club-description">
        {{ club.ownerText }}&hellip;
        <a :href="club.url">
            {{ t.read_more }}
        </a>
    </div>
    <div class="club-stats">
        <ul class="list-inline">
            <li><i class="sh-icon"></i> {{ club.likes }}</li>
            <li><a :href="`${club.reviewUrl}`"><i class="fa fa-comment"></i> {{ club.comments }}</a></li>
        </ul>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ClubCard',
    computed: {
        ...mapState({
            t: state => state.t.club_card
        }),
        coverStyle() {
            return this.club.cover ? `background-image: url(${this.club.cover})` : '';
        }
    },
    props: {
        club: {
            type: Object,
            required: true
        }
    }
};

</script>

<style lang="scss">
@import "~Site/scss/variables";
.club-card {
    @include card;
    margin-bottom: 25px;
    border-radius: 0;
    .coverimage-header-listing {
        margin-bottom: 0;
    }
    .club-description {
        padding: 10px;
        height: 90px;
    }
    .club-location {
        clear: both;
        background-color: #f5f5f5;
        border-bottom: .0625rem solid #e5e5e5;
        padding: 5px 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        position: relative;
        &.club-has-distance {
            padding-right: 50px;
        }
        .club-distance {
            position: absolute;
            right: 10px;
        }
        i {
            margin-right: 2px;
        }
    }
    .club-stats {
        padding: 9px;
        border-top: .0625rem solid #e5e5e5;
        background-color: #f5f5f5;
        a {
            color: $text-color;
        }
        ul {
            display: flex;
            justify-content: space-around;
            margin: 0;
            i {
                margin-right: 2px;
            }
        }
        .sh-icon {
            vertical-align: text-bottom;
        }
    }
    .club-highlight {
        color: #fff;
        position: absolute;
        top: 10px;
        left: 10px;
        font-size: 1.4em;
        text-shadow: 0 0 3px black;
    }
}
@media (max-width: $screen-xs-max) {
    .club-card .coverimage-header-listing {
        height: 110px;
    }
}
</style>
